import { FC } from "react";
import { TableBody, TableCell, TableRow } from "@mui/material";
import { dataCellStyles, rowStyles } from "../utils/constants/tableStyles";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";

interface InternalBillingExplorerTotalTableBodyContentProps {
  gridData: ResourceExplorerGridDataWithId[];
  fieldNames: string[];
  getNestedPropertyValue: (field: string, row: any) => any;
  renderCellComponent: (field: string, value: any, row: any) => React.ReactNode;
}

export const InternalBillingExplorerTotalTableBodyContent: FC<
  InternalBillingExplorerTotalTableBodyContentProps
> = ({ gridData, fieldNames, getNestedPropertyValue, renderCellComponent }) => (
  <TableBody>
    {gridData.map((row, rowIndex) => (
      <TableRow key={rowIndex} sx={rowStyles}>
        {fieldNames.map((field, colIndex) => {
          const value = getNestedPropertyValue(field, row);

          return (
            <TableCell
              key={colIndex}
              align={colIndex === 0 ? "left" : "right"}
              sx={dataCellStyles(colIndex === 0)}
            >
              {renderCellComponent(field, value, row)}
            </TableCell>
          );
        })}
      </TableRow>
    ))}
  </TableBody>
);
